import {useEffect, useCallback} from 'react'
import {useDispatch} from 'redux-react-hook'
import ApiSdk from 'services/callApi'
import {entities as entitiesAction} from 'actions'

function useSymbolInfoDataProvider (symbol) {
  const dispatch = useDispatch()
  const fetchData = useCallback(async () => {
    const {symbolInfo} = await ApiSdk.futures.getSymbolInfo({symbol})
    dispatch(entitiesAction({symbolInfo}))
  }, [dispatch, symbol])

  useEffect(() => {
    fetchData()
  }, [dispatch, fetchData])
}

export default useSymbolInfoDataProvider
